import type { ExactTheme } from "src/lib/emotion/theme.ts";

/**
 * Как выглядит плейсхолдер-чип. Один вид и одно поведение на все редакторы.
 *
 * Чипы рисуют два разных движка — CKEditor в письме и CodeMirror в исходном
 * коде и SMS, — но человек видит одну систему и переключается между полями за
 * секунду. Две копии стилей разъехались бы на первой же правке цвета.
 *
 * Значения — строками, без чисел и пропусков: этот же объект принимает
 * CodeMirror, а он разбирает стили сам и вольностей emotion не понимает.
 */
export const placeholderChipStyle = (
  theme: ExactTheme,
): Record<string, string> => ({
  display: "inline-block",
  padding: "0 8px",
  // Два чипа подряд — обычное дело: имя и фамилия, товар и цена. Без зазора
  // они читаются как один длинный.
  margin: "0 2px",
  borderRadius: "15px",
  // Шрифт задан прямо здесь, а не унаследован: у CKEditor своя типографика для
  // содержимого письма, и унаследованный чип выходил другим шрифтом и другой
  // насыщенности, чем точно такой же чип в соседнем поле.
  fontFamily: theme.fonts.normal,
  fontWeight: String(theme.fontWeights.normal),
  background: theme.colorsV2.white,
  color: theme.colorsV2.grey[800],
  border: `1px solid ${theme.colorsV2.green[500]}`,
  fontSize: "0.9em",
  lineHeight: "1.5",
  whiteSpace: "nowrap",
  cursor: "default",
  userSelect: "none",
  // CKEditor обводит свои предметы жёлтой рамкой при наведении и синей при
  // выделении. В поле исходного кода такой рамки нет и взяться ей неоткуда,
  // поэтому она убрана и здесь: два соседних поля должны вести себя одинаково.
  outline: "none",
});

/** Выделенный чип — тот, который сейчас удалят или заменят. */
export const placeholderChipSelectedStyle = (
  theme: ExactTheme,
): Record<string, string> => ({
  background: theme.colorsV2.green[50],
  borderColor: theme.colorsV2.green[500],
  outline: "none",
});
